import { type RouteLocationRaw, useRouter } from 'vue-router';
import { RouteNames } from '@/core/plugins/router/routeNames';

export function useRouterBack() {
  const $router = useRouter();

  /**
   * Returns to the previous page or to the home page.
   */
  const routerBack = (defaultRoute: RouteLocationRaw) => {
    if (window.history.state?.position <= 1) {
      void $router.replace(
        defaultRoute || {
          name: RouteNames.Home,
        },
      );

      return;
    }

    window.history.back();
  };

  return {
    routerBack,
  };
}
